const TITLE_TEXT = 'Não encontrou o que sente?'
const SUBCOPY_TEXT = 'Fale com a floricultura e monte um pedido do seu jeito.'
const CONTACT_LABEL = 'Falar por e-mail'

export function useConversionBandModel() {
  return {
    titleText: TITLE_TEXT,
    subcopyText: SUBCOPY_TEXT,
    contactLabel: CONTACT_LABEL,
  }
}
